



















































import Vue, { PropOptions } from 'vue'
import Overlay from '@/common/components/Overlay.vue'
import Modal from '@/common/components/Modal.vue'

export default Vue.extend({
  components: {
    Overlay,
    Modal
  },
  props: {
    thumbnailFiles: {
      type: Array,
      required: true
    } as PropOptions<string[]>,
    labels: {
      type: Array,
      required: true
    } as PropOptions<string[]>,
    previewFiles: {
      type: Array,
      required: true
    } as PropOptions<string[]>
  },
  data() {
    return {
      currentThumbnailIndex: 0
    }
  },
  mounted() {
    document.querySelector('body')!.classList.add('is-locked')
  },
  destroyed() {
    document.querySelector('body')!.classList.remove('is-locked')
  },
  methods: {
    isCurrentThumbnail(index: number) {
      return this.currentThumbnailIndex === index
    },
    updateCurrentThumbnail(index: number) {
      this.currentThumbnailIndex = index
    },
    closeModal() {
      this.$emit('onClose')
    }
  }
})
